
import { get, post } from '../utils/http'

export const fetchUsers = (id) => {
  return get('USERS_FETCH', `/admin/org/${id}/users`);
}

export const editUser = (user) => ({ type: 'USERS_EDIT', payload: user })

export const cancelEdit = () => ({ type: 'USERS_CANCEL_EDIT' })

export const showEdit = () => ({ type: 'USERS_SHOW_EDIT' })

const buildUserForm = (id, orgId) => {

  let form = new FormData();
  form.append('id', id);
  form.append('orgId', orgId);

  return form;
}

export const loginUser = (id) => {
  return get('USERS_LOGIN', `/admin/users/${id}`);
};

export const deleteUser = (id, orgId) => {
  return post('USERS_DELETE', '/admin/users/delete', buildUserForm(id, orgId));
};

export const inactivateUser = (id, orgId) => {
  return post('USERS_INACTIVATE', '/admin/users/inactivate', buildUserForm(id, orgId));
};

export const activateUser = (id, orgId) => {
  return post('USERS_ACTIVATE', '/admin/users/activate', buildUserForm(id, orgId));
};

export const resetPassword = (id, orgId) => {
  return post('USERS_RESET_PASSWORD', '/admin/users/resetpassword', buildUserForm(id, orgId));
}

export const save = (user, orgId, expiryDate) => {

  let attributes = ['id', 'email', 'password', 'firstName', 'lastName'];
  let form = new FormData();

  attributes.forEach(a => form.append(a, user[a] || ''));

  form.append('admin', !!user.admin);
  form.append('featureSbtPlus', !!user.featureSbtPlus);

  form.append('orgId', orgId);
  if (expiryDate) {
    form.append('expiryDate', expiryDate);
  }
  return post('USERS_SAVE', '/admin/users/update', form);
}

export const editAttr = (attr, value) => ({ type: 'USER_ATTR_EDIT', payload: { attr, value } });


// WEBPACK FOOTER //
// ./src/user/userActions.js